<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <HerosForm :baseHero="hero" :baseHeroName="name" :loading="loading" @submit-requested="submitRequested"></HerosForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HerosForm from '../forms/HerosForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            hero: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { HerosForm },
    computed:
    {
        ...mapState('heros', ['getHeroByIdOutput']),
    },
    methods: {
        ...mapActions('heros', ['getHeroById']),
        ...mapActions('heros', ['putHero']),
        submitRequested(hero) {
            this.putHero(hero);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'HerosList' });
        }

        this.getHeroById(this.$route.query.id);
    },
    watch:
    {
        getHeroByIdOutput: function(heroOutput)
        {
            if(!heroOutput && !heroOutput.data)
            {
                router.push({ name: 'HerosList' });
            }
            else
            {
                this.hero = heroOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>